import { render, staticRenderFns } from "./materi.vue?vue&type=template&id=afd7ee06&"
import script from "./materi.vue?vue&type=script&lang=js&"
export * from "./materi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports